export const BUSINESS_STRUCTURES = [
  { value: 'sole_trader', label: 'Sole Trader' },
  { value: 'partnership', label: 'Partnership' },
  { value: 'company', label: 'Company' },
  { value: 'trust', label: 'Trust' },
  { value: 'individual', label: 'Individual' },
] as const;

export const USER_STATUS_LABELS: Record<string, string> = {
  active: 'Active',
  pending: 'Pending',
  pending_approval: 'Pending Approval',
  rejected: 'Rejected',
  banned: 'Paused',
  inactive: 'Inactive',
};

export const userStatusLabels: Record<string, string> = {
  ...USER_STATUS_LABELS,
  pending_group: 'Pending (All)',
  invited: 'Invited',
};
